<template>
	<Page animate>
		<template v-slot:content>
			<SafeAreaTop class="absolute" @close="onClose" :closePosition="closePosition" :theme="closeTheme"></SafeAreaTop>

			<div class="promo">
				<img src="@/assets/paywall/food.jpg" alt="" />
			</div>
			<div class="container">
				<div class="title">Exclusive sign-up offer</div>
				<div class="title color-green">7-day free access to all recipes</div>

				<List class="mt-1.5rem" :items="listItems" />
			</div>
		</template>

		<template v-slot:footer>
			<div class="container">
				<div class="product-info">{{ activeProduct.text }}</div>
				<p-button @click.prevent="handleSubmit" label="" :loading="isLoading" cls="btn-green btn-block">
					Add to plan
				</p-button>
			</div>
		</template>
	</Page>
</template>

<script>
import Page from '@/components/Page'
import PButton from '@/components/Button'
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import useApi from '@/composition/api.js'
import useConfig from '@/composition/config.js'
import SafeAreaTop from '@/components/SafeAreaTop.vue'
import List from '@/components/List.vue'
import { inject, onMounted } from '@vue/runtime-core'

export default {
	components: {
		Page,
		SafeAreaTop,
		PButton,
		List
	},

	setup() {
		const amplitude = inject('amplitude')
		const store = useStore()
		const api = useApi()
		const config = useConfig()
		const router = useRouter()

		const next = computed(() =>
			config.get({
				key: 'postPaid.type',
				default_value: 'workbooks'
			})
		)

		const listItems = [
			'Nutritionist-approved recipes',
			'Create your custom meal plan',
			'Make cooking easier',
			'Lose weight and enjoy tasty food'
		]

		const close = (Status = 'Close', nextRoute = null, product = {}) => {
			amplitude.logEvent('Paywall - Close', {
				Layout: 'Workbooks',
				From: store.getters['getSource'],
				Step: 'Paywall',
				Status
			})

			amplitude.logEvent(store.getters['getAmplitudeEventName']('AddProductPaywallDone'), {
				action: Status.toLowerCase(),
				product_type: 'recipes',
				...product
			})

			router.push({
				name: nextRoute || next.value,
				query: {
					Status
				}
			})
		}

		const onClose = () => close('Close')

		let isLoading = computed(() => store.state.isLoading)

		const closeTheme = computed(() =>
			config.get({
				key: 'close_button.theme',
				default_value: 'white-invert'
			})
		)
		const closePosition = computed(() =>
			config.get({
				key: 'paywall.close_button.position',
				default_value: 'right'
			})
		)

		const purchase = (product) => {
			api.purchase({
				productId: product.id,
				onFinish: () => {
					amplitude.logEvent('Paywall - Done', {
						Layout: 'Recipes',
						From: store.getters['getSource'],
						Step: 'Paywall',
						ProductId: product.id,
						Status: 'Purchase'
					})
					close('Purchase', next.value, {
						product_id: product.id,
						duration_month: product.duration_months,
						price: Math.abs(product.product_price),
						currency: product.currency,
						platform: api.getPlatform()
					})
				},
				onError: () => {
					console.log('error')
				},
				onCancel: () => {},
				closeOnSuccess: false
			})
		}

		const products = computed(() => {
			return store.getters['products/getData']([
				{
					id: 'simple_recipes_3_months_7d_trial_low',
					text: 'Free for 7 days, then [price]/12 weeks. Cancel anytime'
				}
			])
		})

		const activeProduct = computed(() => products.value[0])

		const handleSubmit = () => {
			purchase(activeProduct.value)
		}

		onMounted(() => {
			amplitude.logEvent(store.getters['getAmplitudeEventName']('AddProductPaywallShow'), {
				product_ids: products.value.map((product) => product.id),
				product_type: 'recipes',
				prices: products.value.map((product) => product.product_price),
				currency: activeProduct.value.currency
			})
		})

		api.onBackBressed()

		return {
			isLoading,
			handleSubmit,
			onClose,
			closeTheme,
			closePosition,
			activeProduct,
			listItems
		}
	}
}
</script>

<style scoped lang="scss">
.promo {
	display: block;
	max-width: 500px;
	margin-left: auto;
	margin-right: auto;
}

.title {
	font-weight: bold;
	font-size: 1.9rem;
	text-align: center;
	line-height: 1.1;
	margin-top: 1rem;

	& + .title {
		margin-top: 0.6rem;
	}
}

.product-info {
	color: #323653;
	font-size: 0.9rem;
	margin: 1rem 0;
	opacity: 0.8;
}
</style>
